import React from 'react';
import { useCssHandles } from '../../../../utils/functions';

const CSS_HANDLES = ['filters', 'filtersWrapper'];
const FilterNavigatorV3Container = ({ children, componentId }: any) => {
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x-`, CSS_HANDLES);
	const filtersLayoutClasses = withModifiers('filters', 'layout');
	console.log(handles);
	return (
		<div data-selection={componentId} className={`${filtersLayoutClasses}`}>
			<div className={`${handles.filtersWrapper}`}>{children}</div>
		</div>
	);
};

export default FilterNavigatorV3Container;
